import { render, staticRenderFns } from "./SimpleKeyboardAMT.vue?vue&type=template&id=747d8563&scoped=true&"
import script from "./SimpleKeyboardAMT.vue?vue&type=script&lang=js&"
export * from "./SimpleKeyboardAMT.vue?vue&type=script&lang=js&"
import style0 from "./SimpleKeyboardAMT.vue?vue&type=style&index=0&id=747d8563&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747d8563",
  null
  
)

export default component.exports